/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'

export const getCountry = (meta?: any) => ({
  type: 'api/country/GET_COUNTRY',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/country`,
      method: 'GET',
    },
  },
  meta,
})
getCountry.toString = () => 'api/country/GET_COUNTRY'

export const getCountryBilling = (meta?: any) => ({
  type: 'api/country/GET_COUNTRY_BILLING',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/country/billing`,
      method: 'GET',
    },
  },
  meta,
})
getCountryBilling.toString = () => 'api/country/GET_COUNTRY_BILLING'

export const getCountryByCountryIdState = ({ countryId }, meta?: any) => ({
  type: 'api/country/GET_COUNTRY_BY_COUNTRY_ID_STATE',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/countries/${countryId}/states`,
      method: 'GET',
    },
  },
  meta,
})
getCountryByCountryIdState.toString = () => 'api/country/GET_COUNTRY_BY_COUNTRY_ID_STATE'
